import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { NavLink } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import SaveIcon from "@mui/icons-material/Save";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import { getUserWithdrawalcount } from "../../redux/actions/getUserWithdrawalCountAction";
import { updateUserWithdrawalcount } from "../../redux/actions/updateUserWithdrawCountAction";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import EditIcon from "@mui/icons-material/Edit";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { getUserNameContactSuggestionList } from "../../redux/actions/partnerGetUserNameContactSuggestionAction"
import Autocomplete from "@mui/lab/Autocomplete";


const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const GetUserWithdrawalCount = () => {
	const [email, setEmail] = useState("");
	const [mobile, setMobile] = useState("");
	const [page, setPage] = useState(0);
	const [open, setOpen] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [getUserWithdrawalcountStatus, setGetUserWithdrawalcountStatus] =
		useState(false);
	const [getUserWithdrawalcountResArray, setgetUserWithdrawalcountResArray] =
		useState([]);
	const [updateUserWithdrawalCountStatus, setUpdateUserWithdrawalCountStatus] =
		useState(false);
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [notificationOpenModal, setNotificationOpenModal] = React.useState(false);

	const [customerId, setCustomerId] = useState("");
	const [noOfWithdrawalAllowed, setNoOfWithdrawalAllowed] = useState("");
	const [customerOrMobName, setCustomerOrMobName] = useState("");

	const [updateUserWithdrawCounArray, setUpdateUserWithdrawCounArray] =
		useState("");

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const classes = useStyles();
	const dispatch = useDispatch();

	const getUserWithdrawCountRes = useSelector(
		({ getUserWithdrawalCountList }) => getUserWithdrawalCountList
	);
	const getUsernameContactSuggestionRes = useSelector(
		({ partnerGetUsernameContactSuggestionsLists }) => partnerGetUsernameContactSuggestionsLists
	)

	const updateUserWithdrawCountRes = useSelector(
		({ updateUserWithdrawCount }) => updateUserWithdrawCount
	);

	// console.log(
	// 	updateUserWithdrawCountRes,
	// 	"////////////////////////////////////////////////////////"
	// );

	const handleNoticationClose = () => {
		setNotificationOpen(false);
		setNotificationOpenModal(false)
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "email") {
			setEmail(value);
		}

		// if (name === "mobile") {
		// 	// setMobile(value);
		// 	Util.verifyMobile(value) ? setMobile(value) : setMobile(mobile);
		// }
		if (name === "customerOrMobName") {

			//console.log("custttttNammmmee", customerOrMobName)
			setCustomerOrMobName(value)
			// onCustContactFunc(value)


		}

		if (name === "NumberofWithdrawalAllowed") {
			// setNoOfWithdrawalAllowed(value);
			Util.verifyAmount(value)
				? setNoOfWithdrawalAllowed(value)
				: setNoOfWithdrawalAllowed(noOfWithdrawalAllowed);
		}
	};

	const getUserWithdrawalcountStatusFunc = () => {
		if (getUserWithdrawalcountStatus) {
			if (getUserWithdrawCountRes.data.status == "success") {
				setgetUserWithdrawalcountResArray(
					[].concat(
						getUserWithdrawCountRes.data.customerMasterDetailsKYCResponseVOList
					)
				);
			}
			if (getUserWithdrawCountRes.data.status == "failed") {
				setgetUserWithdrawalcountResArray(getUserWithdrawCountRes.data);
				setNotificationOpenModal(true)
				if (
					getUserWithdrawCountRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getUserWithdrawCountRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}

			if (getUserWithdrawCountRes.data.status == "Failed") {
				setgetUserWithdrawalcountResArray(getUserWithdrawCountRes.data);
				if (
					getUserWithdrawCountRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getUserWithdrawCountRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getUserWithdrawCountRes.data.status == "NOT FOUND") {
				setgetUserWithdrawalcountResArray(getUserWithdrawCountRes.data);
			}
		}
	};

	useEffect(() => {
		if (getUserWithdrawCountRes.data.status == "success") {
			setPage(0);
		}
	}, [getUserWithdrawCountRes.data.status]);

	const getUserWithdrawalcountFunc = () => {
		setGetUserWithdrawalcountStatus(true);
		const getUserWithdrawCountReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				email: email,
				// phoneNo: mobile
				phone:customerOrMobName.split("-")[0].substring(1),

			}
		};

		return dispatch(getUserWithdrawalcount(getUserWithdrawCountReq, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getUserWithdrawalcountFunc();
		}
	}, [regenerateTokenRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const updateUserWithdrawCountFunc = () => {
		setOpen(false);
		setUpdateUserWithdrawalCountStatus(true);
		const updateUserWithdrawalCountReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",
				custmerId: customerId
			},
			withDrawalCount: noOfWithdrawalAllowed
		};
		return dispatch(
			updateUserWithdrawalcount(updateUserWithdrawalCountReq, authToken)
		);
	};

	const editUserWithdrawalCount = (customerId, withdrawalCount) => {
		setCustomerId(customerId);
		setNoOfWithdrawalAllowed(withdrawalCount || "");
		setOpen(true);
	};

	useEffect(() => {
		if (getUserWithdrawalcountStatus) {
			getUserWithdrawalcountStatusFunc();
		}
	}, [getUserWithdrawCountRes.data.status]);

	const updateUserWithdrawCount = () => {
		if (updateUserWithdrawalCountStatus) {
			if (updateUserWithdrawCountRes.data.status == "success") {
				setOpen(false);
				setUpdateUserWithdrawCounArray(updateUserWithdrawCountRes.data);
				setNotificationOpen(true);
				getUserWithdrawalcountFunc();
			}
			if (updateUserWithdrawCountRes.data.status == "failed") {
				setOpen(false);
				setUpdateUserWithdrawCounArray(updateUserWithdrawCountRes.data);
				setNotificationOpen(true);
				if (
					updateUserWithdrawCountRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateUserWithdrawCountRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}

			if (updateUserWithdrawCountRes.data.status == "Failed") {
				setOpen(false);
				setUpdateUserWithdrawCounArray(updateUserWithdrawCountRes.data);
				setNotificationOpen(true);
				if (
					updateUserWithdrawCountRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateUserWithdrawCountRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		updateUserWithdrawCount();
	}, [updateUserWithdrawCountRes.data.status]);

	useEffect(() => {
		if (getUsernameContactSuggestionRes.data.status === "success") {
			//console.log("lissttt", getUsernameContactSuggestionRes.data.list)
		}
	}, [getUsernameContactSuggestionRes.data.status])

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getUserContactReq = {
				actionCustomerMasterRequestVO: {
					customerMobileOrName: customerOrMobName,
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				}
			}
			dispatch(getUserNameContactSuggestionList(getUserContactReq, authToken))
			// console.log("userContact", getUserContactReq)
		}
	}, [regenerateTokenRes.data.status])

	const filterOptions = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}

		const filteredOptions = options.filter(
			(option) =>
				option.mobile && option.mobile.includes(inputValue) ||
				option.customerMobileOrName.includes(inputValue)
		);

		return filteredOptions.slice(0, 20);
	}

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item sm={12} md={4} lg={4}>
							<TextField
								size="small"
								type="email"
								label="Email"
								fullWidth={true}
								variant="standard"
								color="primary"
								style={{ marginTop: "3px" }}

								autoFocus={true}
								name="email"
								value={email || ""}	InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
								onChange={handleChange}

							></TextField>
						</Grid>
						{/* <Grid item sm={12} md={4} lg={4}>
							<TextField
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								variant="standard"

								label="Mobile Number"
								fullWidth={true}
								name="mobile"
								value={mobile || ""}
								onChange={handleChange}
							></TextField>
						</Grid> */}
								<Grid item sm={12} md={4} lg={4}>
								<Autocomplete
									id="combo-box-demo"
									options={[].concat(
										getUsernameContactSuggestionRes.data.list || [""]
									)}
									getOptionLabel={(option) => "+" + option.countryCode + " " + option.mobile + "-" + option.customerMobileOrName}
									filterOptions={filterOptions}
									renderInput={(params) => (
										<TextField
											autoFocus
											margin="dense"
											id="name"
											label="Mobile Number"
											style={{ marginTop: "0" }}
											type="text"
											fullWidth
											{...params}
											value={customerOrMobName || ""}
											name="customerOrMobName"
											onBlur={handleChange}
											variant="standard"
											sx={{
												"& .MuiInput-underline:before": {
												  borderBottomColor: "gray", // White color for the underline before focus
												},
												"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
												  borderBottomColor: "gray", // White color on hover
												},
												"& .MuiInput-underline:after": {
												  borderBottomColor: "gray", // White color after focus
												},
											  }}

										/>
									)}
								/>
							</Grid>
						<Grid item sm={12} md={4} lg={4}>
							{/* <Button
                style={{
                  marginLeft: "0.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                  marginTop: "9px",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                onClick={getUserWithdrawalcountFunc}
              >
                Search
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getUserWithdrawalcountFunc}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{getUserWithdrawalcountResArray.length == undefined ||
					!getUserWithdrawalcountStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText "
								>
									User WithDrawal Count Details
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText "
								>
									User WithDrawal Count Details
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											{/* <TableCell
                    align="center"
                    style={{ fontWeight: "bold", color: "white" }}
                  >
                    Sr.No
                  </TableCell> */}
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Customer ID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Email
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Mobile
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Withdrawal Count
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getUserWithdrawalcountResArray &&
											[]
												.concat(getUserWithdrawalcountResArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={index}>
														{/* <TableCell align="center">{index + 1}</TableCell> */}
														<TableCell align="center">
															{row.customerId}
														</TableCell>
														<TableCell align="center">
															{row.customerEmail}
														</TableCell>
														<TableCell align="center">{row.userName}</TableCell>
														<TableCell align="center">
															{row.withdrawalCount}
														</TableCell>
														<TableCell align="center">
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() =>
																	editUserWithdrawalCount(
																		row.customerId,
																		row.withdrawalCount
																	)
																}
															>
																{/* Update */}
																{
																	<EditIcon
																		style={{
																			color: "#fff",
																			fontSize: "20px"
																		}}
																	/>
																}
															</CustomButton>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getUserWithdrawalcountResArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onChangeRowsPerPage={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
				<div>
					<Dialog open={open} onClose={handleClose}>
						<DialogTitle style={{ color: "#484848" }}>
							Update Withdrawal Count
						</DialogTitle>
						<DialogContent>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								variant="standard"
								type="text"
								label="Number of Withdrawal Allowed"
								fullWidth={true}
								name="NumberofWithdrawalAllowed"
								value={noOfWithdrawalAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							></TextField>
						</DialogContent>
						<DialogActions>
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							{/* <Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={updateUserWithdrawCountFunc}
							>
								Save
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={updateUserWithdrawCountFunc}
								endIcon={<SaveIcon />}
							>
								Save <SaveIcon />
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			</Layout>

			{updateUserWithdrawCounArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateUserWithdrawCounArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateUserWithdrawCounArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateUserWithdrawCounArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateUserWithdrawCounArray.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateUserWithdrawCounArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{getUserWithdrawalcountResArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpenModal} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{getUserWithdrawalcountResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default GetUserWithdrawalCount;
